const downloadCsv = (data, filename) => {
	if (!data?.length) return;

	const headers = Object.keys(data[0]);

	const escapeCsvValue = (value) => {
		const stringValue =
			typeof value === 'object' && value !== null
				? JSON.stringify(value)
				: String(value ?? '');

		return `"${stringValue.replace(/"/g, '""')}"`;
	};

	const csv = [
		headers.join(','),
		...data.map((row) =>
			headers.map((header) => escapeCsvValue(row[header])).join(',')
		)
	].join('\n');

	const blob = new Blob([csv], {
		type: 'text/csv;charset=utf-8;'
	});

	const url = URL.createObjectURL(blob);
	const link = document.createElement('a');

	link.href = url;
	link.download = filename;
	link.click();

	URL.revokeObjectURL(url);
};

export const handleDownloadPostQCData = (postQCData) => {
	const allCaptures = postQCData.flat();
	const date = new Date().toLocaleString('en-GB').slice(0, 10);
	downloadCsv(allCaptures, `post-qc-captures-${date}.csv`);
};

export const renderDownloadPostQCDataBtn = (postQCData) => {
	return (
		<button
			type="button"
			className="btn btn-md interactButton"
			onClick={() => handleDownloadPostQCData(postQCData)}
			style={{ width: '250px' }}
		>
			<i className="fa-solid fa-file-arrow-down fa-xl me-3"></i> Download post
			QC data
		</button>
	);
};

export function capFirstLetter(str) {
	if (!str) return str;
	return str.charAt(0).toUpperCase() + str.slice(1);
}
